import { protectAllInputs } from './common/input-security';

import initViewsChart from './cabinet/views';
import initBirthDay from './cabinet/mask';
import initDatePicker from './cabinet/datepicker';
import { initSortable } from './cabinet/sort';
import { initInputCount } from './common/form';
import initRangeSlider from './common/range';
import {
  initImagesUpload,
  initVideosUpload,
  initAudiosUpload,
  initDocumentsUpload,
  initMonoImageUpload,
  initFileUpload,
  initAnyFileUpload,
  initImagesUploadCropper
} from './cabinet/upload';
import {
  initLinkForm,
  initUserLinkForm,
  initContestFormFeeType,
  initContestFormNominationType,
  initWorkFormUserType,
  initWorkFormRepresentative,
  initContestFormUseAge,
  initContestFormAddCategory,
  initContestFormAddNomination,
  initJudgingFormCompareChange,
  initJudgingValueForm
} from './cabinet/form';
import initColorPicker from './cabinet/color-picker';
import {initWorkContentWysiwyg, initWysiwyg, initWysiwygFree, initParticipantNotificationWysiwyg} from './cabinet/wysiwyg';
import initCommentTemplates from './cabinet/comment-templates';
import initTooltip from './cabinet/tooltip';
import initPagePreview from './cabinet/page-preview';
import initEmailSettings from './cabinet/email-settings';
import {initContestCustomFields} from './cabinet/custom-fields';
import {initContestCustomFieldsColumns} from './cabinet/custom-fields-columns';
import initAddNewCustomFields  from './cabinet/add-custom-fields';
import {initAddNewCustomFieldsVariants}  from './cabinet/add-custom-fields-variants';
import initAddNewCustomFieldsColumn  from './cabinet/add-custom-fields-column';
import {initAddNewCustomColumnVariants}  from './cabinet/add-custom-column-variants';
import initAddNewCustomWorkColumn  from './cabinet/add-custom-work-columns';
import initDeleteCustomWorkColumns  from './cabinet/delete-custom-work-columns';
import initCustomTableMultiselect from './cabinet/custom-table-multiselect';
import {initDeleteCustomColumnVariants}  from './cabinet/delete-custom-column-variants';
import {initDeleteCustomColumn}  from './cabinet/delete-custom-column';
import initChangeWorkVariants  from './cabinet/add-change-work-variants';
import { initWorkFields } from './cabinet/work-fields';
import initSelectSearch from './cabinet/select-search';
import {initCompanySuggestions} from './cabinet/company-suggestions';
import {initAddressSuggestions} from './cabinet/address-suggestions';
import initContestUrlSettings  from './cabinet/contest-url-settings';
import { initWorkParticipantStep } from './cabinet/work-user-type-step';
import initFrameWork, { applyFrameFooterCompact, applyWbEmbedViewport } from './common/iframe-work';
import initWbApplications from './wb-applications';
import initWbEmbedUi from './wb-embed-ui';
import initWbWorkDeactivate from './cabinet/wb-work-deactivate';
import { initWorkCommentStep } from './cabinet/work-comment-step';
import { initSaveWorkBetweenStep } from './cabinet/save-work-between-step';
import { initSaveWorkByQuizLimit } from './cabinet/save-work-by-quiz-limit';
import { initContestOrganizerEdit } from './cabinet/contest-organizer-edit';
import { initContestOrganizerAdminsEdit } from './cabinet/contest-organizer-admins-edit';
import { initContestJudgeAdd } from './cabinet/contest-judge-add';
import { initContestJudgeEdit } from './cabinet/contest-judge-edit';
import { initCopyContest } from './cabinet/copy-contest';
import { initPaidContestDraftCount } from './cabinet/paid-contest-draft-count';
import initKludgeWorkNominations from './cabinet/kludge-work-nominations';
import initSubscriptions from './cabinet/subscriptions';
import initWorksListStatusChange from './cabinet/works-list-status-change';
import initWorksListJudgingChange from './cabinet/works-list-judging-change';
import { initCustomRegionFieldSelect } from './cabinet/custom-region-field-select';
import initWorkFieldToggles from './cabinet/organizer-jury-show-work-fields';
import initModals from './cabinet/modals';
import initNotifications from './common/notification';
import initAvatarCabinet from './common/avatar-cabinet';
import {initDropdownMenu} from './common/dropdown';
import initTableCheckedItems from './common/table-checked-items';
import {initTooltipPopup} from './common/tooltip';
import {initSpoiler, initCheckSpoiler} from './common/spoiler';
import initClipboardButtons from '../../common/js/clipboard-btn';
import {initToggleBlocks} from './common/toggle-blocks';
import {initToggleValueBlocks} from './common/toggle-value-blocks';
import {initInputNumber} from './common/input-number';
import {initAppraisalJudgingSave} from './cabinet/appraisal-judging-save';
import {initContestJudgingSettings} from './cabinet/contest-judging-settings';
import initAddQuizSteps from './cabinet/add-quiz-steps';
import initShowQuizSteps from './cabinet/show-quiz-steps';
import initDeleteQuizSteps from './cabinet/delete-quiz-steps';
import {initWorkQuiz} from './cabinet/work-quiz';
import initDeleteFieldVariantFiles from './cabinet/delete-field-variants-files';
import {showDependsParams} from './cabinet/show-custom-fields-params';
import {contestStatusError} from './cabinet/contest-status-error';
import {initContestInfoSettings} from './cabinet/contest-info-settings';
import {initContestCustomFieldsSettings} from './cabinet/contest-custom-fields-settings';
import {initAiTextFieldPromptTest} from './cabinet/ai-text-field-prompt-test';
import initWorkContentNominations from './cabinet/work-content-nominations';
import initNestedCategoriesCheckboxes from './cabinet/nested-categories-checkboxes';
import initContestFavorite from './front/contest-favorite';
import initOrganizerContactsSelect from './cabinet/organizer-contacts-select';
import { initAiImageFields } from './cabinet/ai-image-field';
import {initContestWorkFormatsSettings} from './cabinet/contest-work-formats-settings';
import initOrganizerWorkPdf from './cabinet/organizer-work-pdf';

document.addEventListener('DOMContentLoaded', () => {
  applyWbEmbedViewport();
  applyFrameFooterCompact();
  initFrameWork();
  initWbApplications();
  initWbEmbedUi();
  initWbWorkDeactivate();
  initAiImageFields();
  initRangeSlider();
  initViewsChart();
  initClipboardButtons();
  initDropdownMenu();
  initTableCheckedItems();
  initTooltipPopup();
  initNotifications();
  initAvatarCabinet();
  initBirthDay();
  initDatePicker();
  initSortable();
  initImagesUpload();
  initVideosUpload();
  initAudiosUpload();
  initDocumentsUpload();
  initMonoImageUpload();
  initFileUpload();
  initAnyFileUpload();
  initImagesUploadCropper();
  initLinkForm();
  initUserLinkForm();
  initContestFormFeeType();
  initContestFormNominationType();
  initWorkFormUserType();
  initWorkFormRepresentative();
  initContestFormUseAge();
  initContestFormAddCategory();
  initContestFormAddNomination();
  initJudgingFormCompareChange();
  initJudgingValueForm();
  initWysiwyg();
  initWysiwygFree()
  initParticipantNotificationWysiwyg();
  initWorkContentWysiwyg();
  initCommentTemplates();
  initTooltip();
  initColorPicker();
  initPagePreview();
  initEmailSettings();
  initContestCustomFields();
  initContestCustomFieldsColumns();
  initAddNewCustomFields();
  initAddNewCustomFieldsVariants();
  initAddNewCustomFieldsColumn();
  initAddNewCustomColumnVariants();
  initAddNewCustomWorkColumn();
  initDeleteCustomWorkColumns();
  initCustomTableMultiselect();
  initDeleteCustomColumnVariants();
  initDeleteCustomColumn();
  initChangeWorkVariants();
  initWorkFields();
  initSelectSearch();
  initCompanySuggestions();
  initAddressSuggestions();
  initContestUrlSettings();
  initWorkParticipantStep();
  initWorkCommentStep();
  initSaveWorkBetweenStep();
  initSaveWorkByQuizLimit();
  initContestOrganizerEdit();
  initContestOrganizerAdminsEdit();
  initContestJudgeAdd();
  initContestJudgeEdit();
  initCopyContest();
  initPaidContestDraftCount();
  initKludgeWorkNominations();
  initSubscriptions();
  initWorksListStatusChange();
  initWorksListJudgingChange();
  initCustomRegionFieldSelect();
  initWorkFieldToggles();

  // Protect all inputs initially
  protectAllInputs();

  initModals();
  initSpoiler();
  initCheckSpoiler();
  initToggleBlocks();
  initToggleValueBlocks();
  initAppraisalJudgingSave();
  initContestJudgingSettings();
  initAddQuizSteps();
  initShowQuizSteps();
  initDeleteQuizSteps();
  initWorkQuiz();
  initDeleteFieldVariantFiles();
  showDependsParams();
  contestStatusError();
  initContestInfoSettings();
  initInputCount();
  initInputNumber();
  initContestCustomFieldsSettings();
  initAiTextFieldPromptTest();
  initWorkContentNominations();
  initNestedCategoriesCheckboxes();
  initContestFavorite();
  initOrganizerContactsSelect();
  initContestWorkFormatsSettings();
  initOrganizerWorkPdf();
});
